import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '@macs-frontend/core';
import { ListsUrls } from '@macs-frontend/web-macs/core/utils/consts';
import { Tag } from '@macs-frontend/web-macs/shared/models/tag';

@Component({
  selector: 'md-tags',
  templateUrl: 'tags.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagsComponent),
      multi: true,
    },
  ],
})
export class TagsComponent extends BaseComponent implements ControlValueAccessor {
  ListsUrls = ListsUrls;

  // @ts-expect-error
  tags: Tag[];
  onChangeCallback = (_: any) => {};

  writeValue(tags: Tag[]) {
    this.tags = tags;
  }

  registerOnChange(fn: (_: any) => void) {
    this.onChangeCallback = fn;
  }

  registerOnTouched() {}

  removeTag(tagToDelete: Tag) {
    this.tags = this.tags.filter(tag => tag !== tagToDelete);
    this.onChangeCallback(this.tags);
  }

  addTag(tagToAdd: Tag) {
    this.tags = [...this.tags, tagToAdd];
    this.onChangeCallback(this.tags);
  }

  createTagsFilter() {
    const selectedTags = this.tags;

    return (tags: Tag[]) =>
      tags.filter(
        tag => !selectedTags.some(selectedTag => selectedTag.uuid === tag.uuid),
      );
  }
}
